import { Box, Link } from '@mui/material'
import CompliancePlip from '../../../../components/CompliancePlip'
import { ComplianceStatus } from '../../../../types'
import useCustomer from '../../../../hooks/useCustomer'

interface AEDsAndDevicesProps {
  link: string
}

const AEDsAndDevices = ({ link }: AEDsAndDevicesProps) => {
  const customer = useCustomer()
  const metadata = customer.customerMetadata

  return metadata && (
    <Box>
      <div className='border-box'>
        <CompliancePlip message='' className='dashboard-compliance' status={metadata.device_status} />
        <div className='compliance-message'>
          <p className='card-info'>{metadata.device_message_long}</p>
          <Link className='small-text' href={link}>{metadata.device_status === ComplianceStatus.Inactive ? 'Learn More' : 'View Details'}</Link>
        </div>
      </div>
      <div className='card-footer flex justify-between'>
        {metadata.aed_devices > 0 && (
          <div className="center-text">
            <span className="block text-ot-dashboard">{metadata.aed_devices}</span>
            <span className="text-base">
              <CompliancePlip message='' className='dashboard-compliance small' status={metadata.device_status} />
              AED{metadata.aed_devices > 1 ? 's' : ''}
            </span>
          </div>
        )}
        {metadata.active_standalone_devices > 0 && (
          <div className="center-text">
            <span className="block text-ot-dashboard">{metadata.active_standalone_devices}</span>
            <span className="text-base">
              Device{metadata.active_standalone_devices > 1 ? 's' : ''}
            </span>
          </div>
        )}
      </div>
    </Box>
  )
}

export default AEDsAndDevices